import React from 'react';
import useAppStore from '../AppStore';

export default function BulbContainer({ playlists = [], onClick, track, disabled }) {
    const handleClick = (e) => {
        if (typeof onClick === 'function') onClick(track, e);
    };

    const { setTooltipText } = useAppStore();

    return (
        <button className="bulb-container" onClick={handleClick}
            onMouseEnter={() => setTooltipText("Add/Remove from playlist via playlist controller")} onMouseLeave={() => setTooltipText(null)}
        >
            {playlists && playlists.length > 0 ? (
                playlists.map((p) => <div key={p.id} className="littleBulbOn" />)
            ) : (

                !disabled ?
                    <div className="bulb-container-text">add to...</div> : null
            )}
        </button>
    );
}